import { Container } from '@tribeplatform/react-ui-kit/Layout'
import { SectionHeader } from '@tribeplatform/react-ui-kit/SectionHeader'

interface Props {
  title: React.ReactNode
  description: React.ReactNode
  children: React.ReactNode
}
export const UsagesSection = ({ title, description, children }: Props) => {
  return (
    <Container size="lg" spacing="sm">
      <SectionHeader title={title} description={description} />

      <div className="grid grid-cols-1 @lg:grid-cols-2 gap-5">{children}</div>
    </Container>
  )
}
